import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react'

function SearchCard({searchMovie}) {
    const [searchResult,setSearchResult]=useState([])
    const cards = useRef()
    const handleWheel=(event)=>{
        event.preventDefault();
        cards.current.scrollLeft += event.deltaY;
    }
    
    useEffect(()=>{
        cards.current.addEventListener("wheel",handleWheel)
    },[]);
    useEffect(()=>{
        axios.get(`http://www.omdbapi.com/?apikey=4da8ece9&s=${searchMovie}&type=movie`).then((success)=>{
            setSearchResult(success.data.Search);
         console.log(success.data.Search);
        }).catch((error)=>{
            setSearchResult(error);
        })
     },[searchMovie])
     console.log(searchResult)
  return (
    <div className='container py-4'>
    <h2 className='movies_type'>Maching to Your Searches</h2>
    <div className='cards' ref={cards}>
    {
        searchResult.map((data,index)=>{
            return(
                <div key={index}>
                    <div>
                        <img className='card_img' height="250" src={data.Poster} alt=''/>
                    </div>
                    <p className='card_name'>{data.Title}</p>
                </div>
            )
        })
    }
    </div>
</div>
  )
}

export default SearchCard